/**
 * Action type to set the precall test data.
 */
export const SET_PRECALL_TEST_RESULTS = 'SET_PRECALL_TEST_RESULTS';
/**
 * Type for setting the user's consent for unsafe room joining.
 *
 * {
 *     type: SET_UNSAFE_ROOM_CONSENT,
 *     consent: boolean
 * }
 */
export const SET_UNSAFE_ROOM_CONSENT = 'SET_UNSAFE_ROOM_CONSENT';
